export const normalizeQrCategoryOrder = (value) =>
  Array.isArray(value)
    ? [...new Set(value.filter((id) => typeof id === "string" && id.trim()).map((id) => id.trim()))]
    : [];

export const normalizeQrSubcategoryOrder = (value) =>
  value && typeof value === "object" && !Array.isArray(value)
    ? Object.fromEntries(Object.entries(value)
        .filter(([id]) => id.trim() && !["__proto__", "constructor", "prototype"].includes(id.trim()))
        .map(([id, order]) => [id.trim(), normalizeQrCategoryOrder(order)]))
    : {};

export const orderQrSubcategories = (subcategories = [], savedOrders = {}, categoryId = "") =>
  orderQrCategories(subcategories, normalizeQrSubcategoryOrder(savedOrders)[categoryId] || []);

// Unlisted/new categories keep their original relative order after the saved ones.
export const orderQrCategories = (categories = [], savedOrder = []) => {
  const positions = new Map(normalizeQrCategoryOrder(savedOrder).map((id, index) => [id, index]));
  return categories.map((category, index) => ({ category, index }))
    .sort((a, b) =>
      (positions.get(a.category.id) ?? positions.size) -
      (positions.get(b.category.id) ?? positions.size) || a.index - b.index
    )
    .map(({ category }) => category);
};
